import { Box, Container, GridItem, SimpleGrid } from '@chakra-ui/react';
import { GetServerSidePropsContext } from 'next';
import { getSession } from 'next-auth/react';

import { withSession } from '@/lib/session';
import { withCommonServerSideProps } from '@/lib/withCommonServerSideProps';

import ArticleContent from '@/components/Article/articleContent';
import { H1 } from '@/components/Heading';
import Seo from '@/components/Seo';

import { LocaleProps } from '@/models/props/LocalizationProps';
import { NewsArticleProps } from '@/models/props/NewsArticleProps';
import { NewsService } from '@/services';

function SingleNewsPage(props: NewsArticleProps) {
    const { attributes } = props;

    return (
        <>
            <Seo title={attributes.title} description={attributes.shortDescription} />
            <Container as="section" maxW="container.2xl">
                <Box as="article" pt={10}>
                    <Box textAlign="center">
                        <H1>{attributes.title}</H1>
                    </Box>
                    <SimpleGrid columns={{ xl: 6 }} spacing={{ xl: 7 }}>
                        <GridItem />
                        <GridItem colSpan={{ xl: 4 }}>
                            <ArticleContent content={attributes.content} styles={{ pl: 0 }} />
                        </GridItem>
                    </SimpleGrid>
                </Box>
            </Container>
        </>
    );
}

export const getServerSideProps = withCommonServerSideProps(
    withSession(async (context: GetServerSidePropsContext) => {
        const session = await getSession(context);
        const { query, locale } = context;
        const { slug } = query;
        const data = await NewsService.getNewsBySlug(slug as string, locale as LocaleProps);

        if ((!session && !data) || !data === null) {
            return {
                notFound: true
            };
        }

        return {
            props: data as NewsArticleProps
        };
    })
);

export default SingleNewsPage;
